import { exists } from '@/api'

export interface Authority {
  authorityNo: string
  display: string
  displayKana: string
  specialty: string
  yearOfBirth: string
  work: string
  tag: string
  existsCrossReference: boolean
  bibliographyRealCount: number
  bibliographySetCount: number
  bibliographyContentCount: number
}

export function AuthorityFromJSON(json: any): Authority {
  return {
    authorityNo: exists(json, 'authority_no') ? json.authority_no : '',
    display: exists(json, 'display') ? json.display : '',
    displayKana: exists(json, 'display_kana') ? json.display_kana : '',
    specialty: exists(json, 'specialty') ? json.specialty : '',
    yearOfBirth: exists(json, 'year_of_birth') ? json.year_of_birth : '',
    work: exists(json, 'work') ? json.work : '',
    tag: exists(json, 'tag') ? json.tag : '',
    existsCrossReference: exists(json, 'exists_cross_reference')
      ? json.exists_cross_reference
      : false,
    bibliographyRealCount: exists(json, 'bibliography_real_count')
      ? json.bibliography_real_count
      : 0,
    bibliographySetCount: exists(json, 'bibliography_set_count')
      ? json.bibliography_set_count
      : 0,
    bibliographyContentCount: exists(json, 'bibliography_content_count')
      ? json.bibliography_content_count
      : 0
  }
}
